import { useTranslation } from 'react-i18next'
import { observer } from 'mobx-react'

import { Select } from '../../../../../components/form/select/select'
import { useQuery, useStore } from '../../../../../utils/mst-hooks'
import { shiftsListStore } from '../../../../../models-ui/shifts-list'
import './shifts-location-filter.scss'

const ALL_LOCATIONS = -1

type Props = {
  onLocationChange: () => void
}

export const ShiftsLocationFilter = observer(({ onLocationChange }: Props) => {
  const { t } = useTranslation()
  const { locationsDataView, getLocations } = useStore().data

  const { isLoading } = useQuery(() => getLocations({}))

  const locationOptions = [
    { key: String(ALL_LOCATIONS), label: t('calendar.all_locations'), value: ALL_LOCATIONS },
    ...locationsDataView.map(location => ({
      key: String(location.id),
      label: location.name,
      value: location.id,
    })),
  ]

  if (isLoading) {
    return null
  }

  const currentValue = shiftsListStore.searchFilters.locationId ?? ALL_LOCATIONS

  return (
    <div className="ShiftsLocationFilter">
      <Select
        value={currentValue}
        options={locationOptions}
        onChange={(value: number) => {
          shiftsListStore.setLocationId(value === ALL_LOCATIONS ? null : value)
          onLocationChange()
        }}
        className="ShiftsLocationFilter__select"
      />
    </div>
  )
})
